import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import ReadAxios from '../axiosComponent/read';
const MyPSLineItem = ({
    field: { name },
    form: { setFieldValue },
    ...props
}) => {
    const [content, setcontent] = useState([])
    const [loading, setloading] = useState(false)
    const [options, setOptions] = useState([])
    useEffect(() => {
        let options = []
        if (content.length > 0) {
            content.map((object, index) => {
                let temp = {}
                temp.key = object.psId
                temp.text = object.psDescription
                temp.value = object.psId
                return options[index] = temp
            })
            setOptions(options)
        }
    }, [content])

    let handleSearch = (e, data) => {
        if (data.searchQuery) {
            setloading(true)
            let searchTerm = data.searchQuery
            ReadAxios({ completeURL: `${process.env.REACT_APP_MASTER_API}/psLineItem`, readItems: { searchString: searchTerm } })
                .then((result) => {
                    console.log({result})
                    setcontent(result?.data?.resultSet)
                    setloading(false)
                })
        }
    }
    
    let handleChange = (value, data) => {
        setFieldValue(name, data.value)
    }
    return (<>
        {console.log({options})}
        <Dropdown
            selection
            search
            loading={loading ? true : false}
            style={{ width: '100%' }}
            onChange={handleChange}
            options={options}
            error={props.error}
            onSearchChange={handleSearch}
            noResultsMessage="Search for Result"
            {...props}
        />
</>
    )
}

export default MyPSLineItem